// Modules
import {
  Action,
  MetaReducer,
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
} from '@ngrx/store';

// Constants
import { FEATURE_STORE_KEY } from '@accidents/shared/constants';

// Store - Reducers
import * as ListAccidentsReducer from './list-accidents.reducer';
import * as DetailAccidentReducer from './detail-accident.reducer';
import * as EditAccidentReducer from './edit-accident.reducer';
import * as DetailAccidentTransportationReducer from './detail-accident-transportation.reducer';
import * as ShipAccidentsReducer from './ship-accidents.reducer';

// Store - Actions
import * as AuthActions from '@store/actions/auth.actions';

export interface ModuleState {
  listAccidents: ListAccidentsReducer.AccidentsListState;
  detailAccident: DetailAccidentReducer.AccidentDetailState;
  editAccident: EditAccidentReducer.AccidentEditState;
  detailAccidentTransportation: DetailAccidentTransportationReducer.AccidentDetailTransportationState;
  shipAccidents: ShipAccidentsReducer.IShipAccidentsState;
}

export const reducers: ActionReducerMap<ModuleState> = {
  listAccidents: ListAccidentsReducer.reducer,
  detailAccident: DetailAccidentReducer.reducer,
  editAccident: EditAccidentReducer.reducer,
  detailAccidentTransportation: DetailAccidentTransportationReducer.reducer,
  shipAccidents: ShipAccidentsReducer.reducer,
};

// Method to clear ngrx store once the user is logged out
export function clearState(
  reducer: ActionReducer<ModuleState>
): ActionReducer<ModuleState> {
  return function (
    state: ModuleState | undefined,
    action: Action
  ): ModuleState {
    if (action.type === AuthActions.logoutSuccessful.type) state = undefined;
    return reducer(state, action);
  };
}

// Meta Reducer
export const metaReducers: MetaReducer<ModuleState>[] = [clearState];

// Feature Selector
export const getModuleState =
  createFeatureSelector<ModuleState>(FEATURE_STORE_KEY);
